import React, { useEffect, useState } from "react";
import "./InterestedCategories.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoriesListApi } from "../../../../services/common";
import { setDefaultLocale } from "react-datepicker";
import { LoadingButton } from "../../../../Components/header/form";
import { updateUserProfileApi } from "../../../../services/auth";
import { toastMessage } from "../../../../utils/toastMessage";
import { setShowAuth } from "../../../../store/slices/showAuthSlice";
import useShimmer from "../../../../hooks/useShimmer";
import InterestedCategoriesShimmer from "../../../../shimmer/interestedCategories/InterestedCatgeories";
import CmsShimmer from "../../../../shimmer/CMS/CmsShimmer";

const InterestedCategories = () => {
  const [showShimmer, setShowShimmer] = useShimmer(InterestedCategoriesShimmer);
  const { showAuth } = useSelector((state) => state?.showAuth);
  const dispatch = useDispatch();
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [loading, setLoading] = useState(false);

  //   Fetching Category List
  const fetchCategoryList = async () => {
    try {
      setShowShimmer(true);
      const { data } = await fetchCategoriesListApi();
      const { success, data: response } = data;
      if (success) {
        setCategoryList(response);
      } else {
        setCategoryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  //   Handle Select All
  const handleSelectAllChange = (e) => {
    const { checked } = e.target;
    setSelectedCategory(
      checked && Array.isArray(categoryList) ? [...categoryList] : []
    );
  };

  //   Selected Category
  const handleSelectedCategory = (category) => {
    setSelectedCategory((prev) => {
      const tempCategory = [...prev];
      const index = tempCategory?.findIndex((d) => d?._id === category?._id);

      if (index !== -1) {
        tempCategory.splice(index, 1);
      } else {
        tempCategory.push(category);
      }

      return tempCategory;
    });
  };

  useEffect(() => {
    setSelectedCategory(showAuth?.interestedCategories);
  }, [showAuth?.interestedCategories]);

  useEffect(() => {
    fetchCategoryList();
  }, []);

  // console.log(selectedCategory, "selectedCategory");

  const updatedInterestedCategory = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append(
        "interestedCategories",
        selectedCategory?.map((data) => data?._id)
      );
      const { data } = await updateUserProfileApi(formData);
      const { success, message, data: response } = data;
      toastMessage(
        "Interested Category Update Successfully",
        success ? "success" : "error",
        "createUser"
      );
      if (success) {
        dispatch(
          setShowAuth({ ...showAuth, interestedCategories: selectedCategory })
        );
      } else {
        toastMessage(message, "error", "createUser"
        );
      }
    } catch (e) {
      console.log(e.message);
    } finally {
      setLoading(false);
    }
  };

  // interestedCategories: selectedCategory?.map((data) => data?._id),

  return (
    <>
      <div className="interasted_category">
        <div className="container_category">
          <div className="interested_title">
            <h2>Interested Categories</h2>
          </div>

          {showShimmer || (
            <div className="select-all">
              <label>
                Select All
                <input
                  type="checkbox"
                  checked={
                    categoryList &&
                    categoryList.length > 0 &&
                    categoryList?.every((category) =>
                      selectedCategory?.some(
                        (selected) => selected?._id === category?._id
                      )
                    )
                  }
                  onChange={handleSelectAllChange}
                />
              </label>
            </div>
          )}

          {showShimmer || (
            <div className="btn_groups">
              {/* {categoryList &&
              categoryList?.map((data) => (
                <button
                  type="button"
                  key={data?._id}
                  className="btn btns active"
                >
                  {data?.name}
                </button>
              ))} */}

              {categoryList?.map((data) => {
                const isActive =
                  selectedCategory &&
                  selectedCategory.length > 0 &&
                  selectedCategory?.some((d) => d?._id === data?._id);
                return (
                  <button
                    type="button"
                    key={data?._id}
                    className={`btn btns ${isActive ? " btn1 active" : ""}`}
                    onClick={() => handleSelectedCategory(data)}
                  >
                    {data?.name}
                  </button>
                );
              })}

              {/* <button type="button" className="btn btns active">
              Sports
            </button>
            <button type="button" className="btn btns ">
              Technology
            </button>
            <button type="button" className="btn btns">
              Economy
            </button>
            <button type="button" className="btn btns">
              Health
            </button>
            <button type="button" className="btn btns">
              Politics
            </button>

            <button type="button" className="btn btns">
              Fitness
            </button>
            <button type="button" className="btn btns">
              Cooking
            </button>
            <button type="button" className="btn btns">
              Logistics
            </button>
            <button type="button" className="btn btns">
              Real estate
            </button> */}
            </div>
          )}

          <div className="ctegories_save_btn">
            <button className="delete_btn">Delete Account</button>

            <LoadingButton
              className={`save_and_update ${!selectedCategory?.length ? "cstm_disabled_btn" : ""
                }`}
              onClick={updatedInterestedCategory}
              isDisabled={!selectedCategory?.length}
              loading={loading}
            >
              Save & Update
            </LoadingButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterestedCategories;
